module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEuSURBVHgB1dfREcIgEARQYgWWYGe2Ygl2YCnaSezkjKPMrAgxwN2x7mdCuPcR4Ajh3yMih0CaxbZPH1zllUsgy2I6PmHpQwwNOmJz4BMbGrFf4PcAGnSKXTKXBg5H57CrG8JIdDUWPnRHN2NhAjd0NxYmMkerYWFCM7Q6FiZWR5thoYAa2hwLhbrRblgo2Ix2x0LhavQwLAA2o4djAfITTYMFUBFNh43JoWmxMRk0LzamgFbB7oJNcjeD2zRN98CWzD+bXYgUKSywMyV6bTcQttu4bNi6aNBSsc8OR0vDoTAMLR0nmDtaFI5bN7Qo9gbmaDFoZMzQYth1qaPFoUVUQ4tjP9uN9sRCzTb0CCzUrkOPxIJhG5oBC5Z1NBMWTB/o9CUVNgbR6YuZDRsT0Q8+tTOWBxr3JQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = JA1j
// module chunks = 1